<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-checkout">
    <div class="flex flex-wrap -mr-4">
      <!--  CHECKOUT           -->
      <div class="w-full flex flex-wrap">
        <div class="vx-col w-full sm:w-1/2 lg:w-1/3 pr-4 pb-4">
          <vx-card class="p-2">
            <div class="text-center">
              <h4 class="text-grey">Abonament na {{ membershipDays }} dni</h4>
            </div>
            <div class="text-center mt-4">
              <h2>{{ membershipPrice }} zł</h2>
            </div>
            <div class="text-center mt-4">
              <p>Wartości odżywcze widoczne przez {{ membershipDays }} dni.</p>
              <p class="mt-2">Dostęp do stworzonych produktów po wygaśnięciu abonamentu</p>
              <p class="mt-2">Darmowe aktualizacje</p>
              <p class="mt-2">Koszt całkowity to {{ membershipPrice }} zł netto</p>
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full sm:w-2/2 lg:w-2/3 pr-4 pb-4">
          <vx-card :title="'Podsumowanie'">

            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-input class="w-full mt-4" label="Nazwa firmy" v-model="user_data.company"
                          v-validate="'required'" name="company"/>
                <span class="text-danger text-sm" v-show="errors.has('company')">{{
                    errors.first('company')
                  }}</span>
              </div>
              <div class="vx-col w-full">
                <vs-input class="w-full mt-4" label="Ulica" v-model="user_data.street"
                          v-validate="'required'" name="street"/>
                <span class="text-danger text-sm" v-show="errors.has('street')">{{
                    errors.first('street')
                  }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/3 w-full">
                <vs-input class="w-full mt-4" label="Kod pocztowy" v-model="user_data.zip_code"
                          v-validate="'required'" name="zip_code"/>
                <span class="text-danger text-sm"
                      v-show="errors.has('zip_code')">{{ errors.first('zip_code') }}</span>
              </div>
              <div class="vx-col md:w-2/3 w-full">
                <vs-input class="w-full mt-4" label="Miasto" v-model="user_data.city" type="city"
                          v-validate="'required'" name="city"/>
                <span class="text-danger text-sm" v-show="errors.has('city')">{{
                    errors.first('city')
                  }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-input class="w-full mt-4" label="NIP" v-model="user_data.nip"
                          v-validate="'required'" name="nip"/>
                <span class="text-danger text-sm" v-show="errors.has('nip')">{{
                    errors.first('nip')
                  }}</span>
              </div>
              <div class="vx-col w-full">
                <vs-input class="w-full mt-4" label="Numer telefonu" v-model="user_data.mobile"
                          v-validate="'numeric'" name="mobile"/>
                <span class="text-danger text-sm" v-show="errors.has('mobile')">{{
                    errors.first('mobile')
                  }}</span>
              </div>
              <div class="vx-col w-full">
                <vs-input class="w-full mt-4" label="Kod promocyjny" v-model="user_data.promo"
                          v-validate="'alpha_num'" name="promo"/>
                <span class="text-danger text-sm" v-show="errors.has('promo')">{{
                    errors.first('promo')
                  }}</span>
              </div>
            </div>

            <!-- Pay Button -->

            <div class="text-center place-self-center">
              <vs-button :disabled="!regulaminAccepted" v-on:click="submitForm(membershipID)" class="mt-4 shadow-lg" type="gradient"
                         color="#28c76f" gradient-color-secondary="#28c76f">Kupuję i płacę
              </vs-button>
              <div class="d-flex align-items-center mt-2" style="display: flex;">
                <vs-checkbox v-model="regulaminAccepted" class="mr-1" />
                <span style="font-size: 0.9rem;">
                  kupując pakiet VITME akceptujesz
                  <a target="_blank" href="http://kalkulator.vitme.pl/regulamin">Regulamin serwisu</a>
                </span>
              </div>

            </div>
          </vx-card>
        </div>

      </div>

    </div>

    <div class="w-full flex flex-wrap mb-4">

    </div>

  </div>
</template>

<script>
import UserEditTabAccount from './UserEditTabAccount.vue'
import {Validator} from 'vee-validate';
import axios from 'axios'


// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  // components: {
  //   UserEditTabAccount
  // },
  data() {
    return {
      password: null,
      regulaminAccepted: false,
      passwordConfirm: null,
      memberships: [
        {
          id: 1,
          days: 30,
          price: "289,00"
        },
        {
          id: 2,
          days: 180,
          price: "999,00"
        },
        {
          id: 3,
          days: 360,
          price: "1490,00"
        }
      ],
      membershipDays: 30,
      membershipPrice: "289,00",
      membershipID: 1,
      user_data: {},
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    fetchOne(userId) {
      let url = process.env.VUE_APP_API_ENDPOINT + '/v1/user/' + userId;
      this.$http.get(url).then(response => {
        this.user_data = response.data.data.data;
      });
    },
    submitForm(subscriptionId) {
      this.$validator.validateAll().then(result => {
        console.log(this.$validator);
        if (result) {
          this.paymentOption(subscriptionId);
        }
      })
    },
    paymentOption(subscriptionId) {
      let requestObject = {
        // url: process.env.VUE_APP_API_ENDPOINT + '/v1/payments/request',
        url: process.env.VUE_APP_API_ENDPOINT + '/v1/payments/request-payu',
        method: 'POST',
        data: {
          subscription: subscriptionId,
          userId: this.user_data.id,
          email: this.user_data.email,
          companyName: this.user_data.company,
          companyStreet: this.user_data.street,
          companyZipCode: this.user_data.zip_code,
          companyCity: this.user_data.city,
          companyNIP: this.user_data.nip,
          companyMobile: this.user_data.mobile,
          companyPromo: this.user_data.promo
        }
      }
      this.$http.request(requestObject).then(response => {
        console.log('mem resp', response);
        if (typeof response.data.data.url !== undefined) {
          window.location.href = response.data.data.url;
        } else {
          this.$vs.dialog({
            color: 'warning',
            title: `Błąd`,
            text: 'Wystąpił błąd podczas wybierania płatności. Spróbuj jeszcze raz lub skontaktuj się z administratore,',
            accept: this.acceptAlert
          })
        }
      });
    }
  },
  created() {
    this.fetchOne(this.activeUserInfo.id);
    this.membershipID = this.$route.params.id;
    this.memberships.forEach((membership) => {
      if(membership.id === this.membershipID) {
        this.membershipDays = membership.days;
        this.membershipPrice = membership.price;
        console.log('Days - ' + this.membershipDays);
      }
    });
  }
}

</script>
